import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TenantEnvService {
  private envBaseUrl = '';
  private tenantName = '';

  setEnvBaseUrl(baseUrl: string): void {
    this.envBaseUrl = (baseUrl ?? '').trim();
  }

  getEnvBaseUrl(): string {
    return this.envBaseUrl;
  }

  setTenantName(tenantName: string): void {
    this.tenantName = (tenantName ?? '').trim().toLowerCase();
  }

  getTenantName(): string {
    return this.tenantName;
  }
}
